var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3125 0.25V3.375H8.0625C5.49219 3.375 3.375 5.49219 3.375 8.0625V14.3125H0.25V23.6875H9.625V14.3125H6.5V8.0625C6.5 7.17812 7.17812 6.5 8.0625 6.5H14.3125V9.625H23.6875V0.25H14.3125ZM17.4375 3.375H20.5625V6.5H17.4375V3.375ZM25.25 3.375V6.5H29.9375C30.8219 6.5 31.5 7.17812 31.5 8.0625V14.3125H28.375V23.6875H37.75V14.3125H34.625V8.0625C34.625 5.49219 32.5078 3.375 29.9375 3.375H25.25ZM3.375 17.4375H6.5V20.5625H3.375V17.4375ZM31.5 17.4375H34.625V20.5625H31.5V17.4375ZM3.375 25.25V29.9375C3.375 32.5078 5.49219 34.625 8.0625 34.625H14.3125V37.75H23.6875V28.375H14.3125V31.5H8.0625C7.17812 31.5 6.5 30.8219 6.5 29.9375V25.25H3.375ZM31.5 25.25V29.9375C31.5 30.8219 30.8219 31.5 29.9375 31.5H25.25V34.625H29.9375C32.5078 34.625 34.625 32.5078 34.625 29.9375V25.25H31.5ZM17.4375 31.5H20.5625V34.625H17.4375V31.5Z",
    fill: "#044D9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/blocks.ecc0b7538ce70de59fb2c5d594541d97.svg";
export { ForwardRef as ReactComponent };